jQuery(document).ready(function ($) {

// ie fix, adds class to html doc so we can style stuff differently for ie
    if (document.documentMode === 10 || document.documentMode === 11) {
        $('html').addClass('ie');
    }

});
